module.exports = __webpack_public_path__ + "static/media/premierOneLeftSeatTaken.501c4810.svg";